import { Link } from "react-router-dom";
import { Box, Button } from "@mui/material";

//import { FONT_SECONDARY } from "@/theme/typography";
import { ROUTES } from "@/utils/navigation";
// import { viewDemoLink } from "@/utils/staticData/demoLink";

// import AppleIcon from "@/assets/icons/hero/apple.svg?react";
// import StarIcon from "@mui/icons-material/Star";

const Buttons = () => {
  //const rating = [1, 2, 3, 4, 5];

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={2}
        mb={3}
        maxWidth={460}
        mx={{ xs: "auto", lg: 0 }}
      >
        <Button
          component={Link}
          fullWidth
          to={ROUTES.solutions}
          variant="contained"
        >
          Get started
        </Button>
        <Button
          component={Link}
          to={ROUTES.contactUs}
          variant="outlined"
          fullWidth
          color="secondary"
          target="_blank"
        >
          Request a Demo
        </Button>
      </Box>

      {/* <Box
        display="flex"
        alignItems="center"
        justifyContent={{ xs: "center", lg: "start" }}
        mb={{ xs: 6.75 }}
      >
        {rating.map((item) => (
          <StarIcon
            key={item}
            sx={{ color: "text.primary", "&:last-of-type": { mr: 2 } }}
            fontSize="small"
          />
        ))}
        <Box mr={1.5}>
          <AppleIcon />
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="text.secondary"
          fontFamily={FONT_SECONDARY}
        >
          4.9
        </Typography>
      </Box> */}
    </>
  );
};

export default Buttons;
